export const ADULT_TITLE_OPTIONS = [
  { label: 'Mr', value: 'Mr' },
  { label: 'Mrs', value: 'Mrs' },
  { label: 'Miss', value: 'Miss' },
  { label: 'Ms', value: 'Ms' },
  { label: 'Mx', value: 'Mx' },
  { label: 'Master', value: 'Master' },
  { label: 'Dr', value: 'Dr' },
  { label: 'Prof', value: 'Prof' },
  { label: 'Rev', value: 'Rev' },
  { label: 'Cpt', value: 'Cpt' },
  { label: 'Sir', value: 'Sir' },
  { label: 'Dame', value: 'Dame' },
  { label: 'Lord', value: 'Lord' },
  { label: 'Lady', value: 'Lady' },
];
export const CHILD_TITLE_OPTIONS = [
  { label: 'Master', value: 'Master' },
  { label: 'Miss', value: 'Miss' },
];
